module.exports = __webpack_public_path__ + "static/media/sad-empty-state.a51f228a.png";